import React from 'react';
import Dialog from './Dialog';

function RestoreModal({ 
  isVisible, 
  onCancel, 
  onConfirm, 
  previewData 
}) {
  if (!previewData || !previewData.preview_items) {
    return null;
  }

  return (
    <Dialog
      isOpen={isVisible}
      title="Confirm Restore"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Restore"
      cancelText="Cancel"
      confirmButtonColor="bg-green-600"
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          The following items will be restored to their original locations:
        </p>
        
        <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-3">
          {previewData.preview_items.map((item, index) => (
            <div key={index} className="mb-3 last:mb-0">
              <div className="font-medium text-gray-900">
                {item.item_name}
              </div>
              <div className="text-sm text-gray-600 mt-1">
                Will be restored to: {item.original_location.path_string}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong> If the original location no longer exists, 
            items will be restored to your personal space root folder.
          </p>
        </div>
      </div>
    </Dialog>
  );
}

export default RestoreModal;